import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import styles from './styles/ShopList.scss';

function ShopListComponent({ landingPage }) {
    const list = landingPage.list || {};
    return (
        <React.Fragment>
            {!!list.title && <h3 className={styles.title}>{list.title}</h3>}
            {(list.listGroups || []).map((group, i) => {
                const groupTnSuffix = (group.title || '').toLowerCase().replace(/ /g, '-');
                const items = group.listItems || [];
                if (!items.length) {
                    return null;
                }
                return (
                    <React.Fragment key={i}>
                        <h3 className={styles.groupTitle} data-tn={`title-${groupTnSuffix}`}>
                            {group.title}
                        </h3>
                        <ul data-tn={`shop-list-group-${groupTnSuffix}`} className={styles.list}>
                            {items.map(item => {
                                if (!item.url) {
                                    return null;
                                }
                                const tnSuffix = (item.title || '')
                                    .toLowerCase()
                                    .replace(/ /g, '-');
                                return (
                                    <li key={item.url} className={styles.listItem}>
                                        <a
                                            className={styles.link}
                                            href={item.url}
                                            data-tn={`shop-list-${tnSuffix}`}
                                        >
                                            <span className={styles.imageWrapper}>
                                                <img className={styles.image} src={item.imageUrl} />
                                            </span>
                                            <span className={styles.itemTitle}>{item.title}</span>
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    );
}

ShopListComponent.propTypes = {
    landingPage: PropTypes.object.isRequired,
};

export const ShopList = createFragmentContainer(ShopListComponent, {
    landingPage: graphql`
        fragment ShopList_landingPage on LandingPage {
            list {
                title
                listGroups {
                    title
                    listItems {
                        imageUrl
                        title
                        url
                    }
                }
            }
        }
    `,
});
